// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M10 2.23C10.05 2.04 9.87 1.93 9.68 2.05C8.29 2.87 4.32 6.86 3.61 7.58C3.56 7.63 3.58 7.72 3.65 7.74L7.24 9.03C7.34 9.06 7.4 9.17 7.37 9.27L6 13.77C5.94 13.96 6.13 14.07 6.32 13.95C7.88 13.03 11.71 9.15 12.39 8.45C12.44 8.4 12.42 8.31 12.36 8.29L8.81 6.97C8.72 6.93 8.66 6.83 8.69 6.72L10 2.23Z',
];
